module.exports = __webpack_public_path__ + "static/media/des4.667520bb.jpg";